import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../../components/page/Page'
import { routes } from '../../../../constants'
import { actions } from '../pbindicador.actions'
import { DefaultToolBar } from '../../../../components/toolbar/DefaultToolBar'
import _ from 'lodash'
import { PbIndicadorForm } from './PbIndicadorForm'
import stoageService from '../../../../services/stoage.service'

const mapStateToProps = (state) => {
  const record = state.crudPbIndicadorState.currentRecord

  return {
    record,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.setField(field, valor))
    },
    executeCommand: (params) => dispatch(actions.executeCommand(params)),
  }
}

class PbIndicadorFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      oidEmpresa: null,
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_PUBLIC_INDICADOR}`)
    }
  }

  componentDidMount() {
    // const split = this.props.location.pathname.split('/')
    const oidEmpresa = 35 //Fixo para BOM PASTOR ESSA TELA     split[split.length - 1]
    this.setState({ oidEmpresa: oidEmpresa })
    stoageService.setCompany({ oid: oidEmpresa })
  }

  componentWillUnmount() {}

  loadFavorito() {}

  changeFavorito() {}

  buildHeader = () => {
    return (
      <div>
        <DefaultToolBar listPageContainer={this} title={'Parceiro'} hideFavorito={true} />
      </div>
    )
  }

  onClickCadastrarIndicador = () => {
    const record = this.props.record
    const params = {
      oidEmpresa: this.state.oidEmpresa,
      oidUnidade: _.get(record, 'unidade.id', null),
      nomeParceiro: _.get(record, 'nome', null),
      cpfParceiro: _.get(record, 'cpf', null),
      foneParceiro: _.get(record, 'telefone', null),
      emailParceiro: _.get(record, 'email', null),
      tipoChavePix: _.get(record, 'tipoChavePix', null),
      chavePix: _.get(record, 'chavePix', null),
    }
    this.props.executeCommand(params)
  }

  canCadastrarIndicador = () => {
    const record = this.props.record
    return (
      !_.isEmpty(_.get(record, 'nome', '')) &&
      !_.isEmpty(_.get(record, 'cpf', '')) &&
      !_.isEmpty(_.get(record, 'telefone', '')) &&
      !_.isEmpty(_.get(record, 'email', '')) &&
      !_.isEmpty(_.get(record, 'tipoChavePix', '')) &&
      !_.isEmpty(_.get(record, 'chavePix', '')) &&
      !_.isEmpty(_.get(record, 'unidade', ''))
    )
  }

  render() {
    const content = (
      <PbIndicadorForm
        record={this.props.record}
        setField={this.props.setField}
        onClickCadastrarIndicador={this.onClickCadastrarIndicador}
        canCadastrarIndicador={this.canCadastrarIndicador}
      />
    )

    return <Page content={content} header={this.buildHeader()} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PbIndicadorFormPageContainer)
